// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
    background-color: #223263;
    color: #F8F9FA;
    padding: 20px;
    text-align: justify;
}

.footer-title {
    text-align: center;
    font-size: 2em;
    margin-bottom: 20px;
}

.bert{
    text-decoration: none;
    color: inherit;
}

.footer-content {
    display: flex;
    justify-content: space-between;
    gap: 20px;
    font-size: 1em;
    line-height: 1.6;
    margin: 2% 15%;
}

.footer-content div {
    width: 48%;
}

@media screen and (max-width: 700px) {
    .footer-content {
        flex-direction: column;
        margin: 0 15%;
    }

    .footer-content div {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/Footer.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,cAAc;IACd,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,sBAAsB;QACtB,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".footer {\n    background-color: #223263;\n    color: #F8F9FA;\n    padding: 20px;\n    text-align: justify;\n}\n\n.footer-title {\n    text-align: center;\n    font-size: 2em;\n    margin-bottom: 20px;\n}\n\n.bert{\n    text-decoration: none;\n    color: inherit;\n}\n\n.footer-content {\n    display: flex;\n    justify-content: space-between;\n    gap: 20px;\n    font-size: 1em;\n    line-height: 1.6;\n    margin: 2% 15%;\n}\n\n.footer-content div {\n    width: 48%;\n}\n\n@media screen and (max-width: 700px) {\n    .footer-content {\n        flex-direction: column;\n        margin: 0 15%;\n    }\n\n    .footer-content div {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
